import * as React from 'react'
import { Card, LARGE_ICON_BASE_SRC } from '../../../Shared/index'
import { studentsCreate, teacherCreates } from './add_students'

const studentAccountsSrc = `${LARGE_ICON_BASE_SRC}/student-accounts-green.svg`
const joinLinkSrc = `${LARGE_ICON_BASE_SRC}/join-link-green.svg`

interface StudentOptionsProps {
  next: (event) => void;
  setStudentOption: Function;
  close: (event) => void;
}

export default class StudentOptions extends React.Component<StudentOptionsProps> {

  renderBody() {
    return (
      <div className="create-a-class-modal-body modal-body">
        <h3 className="title">How do you want to add your students?</h3>
        <div className="quill-cards">
          <Card
            color="green"
            header="Students create their own accounts"
            imgAlt=""
            imgSrc={joinLinkSrc}
            onClick={() => { this.props.setStudentOption(studentsCreate) }}
            text="Get a unique link that students can use to create accounts and join your class."
          />
          <Card
            color="green"
            header="Create accounts for students"
            imgAlt=""
            imgSrc={studentAccountsSrc}
            onClick={() => { this.props.setStudentOption(teacherCreates) }}
            text="Create accounts by inputting each student name. You'll get downloadable login information to share with your students."
          />
        </div>
      </div>
    )
  }

  renderFooter() {
    const { next, close } = this.props
    return (
      <div className="create-a-class-modal-footer">
        <div className="buttons-container">
          <button className="quill-button outlined medium focus-on-light" onClick={close}>Cancel</button>
          <button className="quill-button contained medium focus-on-light" onClick={next}>Skip</button>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="create-a-class-modal-content">
        {this.renderBody()}
        {this.renderFooter()}
      </div>
    )
  }
}
